import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, from, map, catchError, switchMap } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class ApiComponentServices {
  constructor(
    private http: HttpClient,
    private authService: AuthService,
  ) {}

  getAccountData(
    accountNumber: string,
    qrId: string,
    accountKey: string,
    isChatSupport: boolean = false,
  ): Observable<any> {
    return from(this.authService.getAccessToken()).pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        });

        return this.http
          .get<any>(
            `${environment.apiBaseURL}/api/getAccountAndDeviceDetails?accountNumber=${accountNumber}&qrId=''&accountKey=${accountKey}&isChatSupport=${isChatSupport}`,
            { headers },
          )
          .pipe(
            map((res: any) => {
              return res;
            }),
            catchError((error) => {
              console.error('Error in getAccountData API:', error);
              throw error;
            }),
          );
      }),
      catchError((error) => {
        console.error('Error getting access token for Account Data:', error);
        throw error;
      }),
    );
  }

  mapAccountWithQRData(mapAccount: any): Observable<any> {
    return from(this.authService.getAccessToken()).pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        });

        return this.http
          .post<any>(
            `${environment.apiBaseURL}/api/mapAccountWithQRData`,
            JSON.stringify(mapAccount),
            { headers },
          )
          .pipe(
            map((res: any) => {
              return res;
            }),
            catchError((error) => {
              console.error('Error in mapAccountWithQRData API:', error);
              throw error;
            }),
          );
      }),
      catchError((error) => {
        console.error('Error getting access token for Map Account:', error);
        throw error;
      }),
    );
  }

  getQRMappedInfo(qrId: any): Observable<any> {
    return from(this.authService.getAccessToken()).pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        });

        return this.http
          .get<any>(
            `${environment.apiBaseURL}/api/getQRMappedInfo?qrId=${qrId}`,
            { headers },
          )
          .pipe(
            map((res: any) => {
              return res;
            }),
            catchError((error) => {
              console.error('Error in getQRMappedInfo API:', error);
              throw error;
            }),
          );
      }),
      catchError((error) => {
        console.error('Error getting access token for QR Mapped Info:', error);
        throw error;
      }),
    );
  }
}
